module.exports = __webpack_public_path__ + "img/lt.27dfb2e5.png";